/**
 * @file DisableWorkerDialog.jsx
 * @description DisableWorkerDialog component for displaying and managing disable worker dialog.
 * @component DisableWorkerDialog
 * @exports DisableWorkerDialog - Main component for displaying and managing disable worker dialog.
 */

import React from "react";
import { Button, Box } from "@mui/material";
import { WORKER_STRINGS } from "../../../common/constants/ivrModule/workerConstants.js";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const DisableWorkerDialog = ({
    open,
    selectedWorker,
    onConfirmDisable,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={WORKER_STRINGS.DISABLE_WORKER}
                actions={
                    <>
                        <Button
                            variant={VARIANTS.CONTAINED}
                            color={BUTTON_COLORS.PRIMARY}
                            onClick={() => onConfirmDisable(selectedWorker)}
                        >
                            {STRINGS.CONFIRM}
                        </Button>
                    </>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {WORKER_STRINGS.CONFIRM_DISABLE} {selectedWorker?.id}?
                </Box>
            </DialogComponent>
        </>
    )
};

export default DisableWorkerDialog;